import { useState } from "react";
import { AttendanceChatFilterProps } from "..";
import { use3cPlusContext } from "contexts/Context3cPlus";
import { DropdownOptionProps } from "components/dropdown";
import { Box, Button, Center, Flex, Text } from "@chakra-ui/react";
import { NewDropdown } from "components/dropdown/new-dropdown";
import {
  dropdownConvenioAtendimento,
  dropdownTabulacao,
} from "components/atendimentos-components/atendimento-form/fields-data";
import { Popover } from "components/popover";
import { Filter2Icon } from "components/vectors/filter-icon";
import { Checkbox } from "components/checkbox";
import { CalendarFilter } from "components/atendimentos-components/attendance-filter/calendar-filter";
import { etapaDropdownArray } from "components/atendimentos-components/kanban-and-table-atendimento/kanban/parts/utils";
import { IconButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";
import { DeleteIcon } from "@chakra-ui/icons";
import { GanhosPerdidosSwitch } from "components/atendimentos-components/pagina-atendimento/ganhos-perdidos-switch";

export const chatsFilterButtonsFontSize = { base: "12px", "2xl": "12px" };

export function AttendanceFilterChats({
  setFilter,
  filters,
  copyFilters,
  setCopyFilters,
  setUsersList,
  usersList,
  isLoadingUsers,
  disabledFilter,
  setDisabledFilter,
}: {
  filters: AttendanceChatFilterProps;
  setFilter: React.Dispatch<React.SetStateAction<AttendanceChatFilterProps>>;
  copyFilters: AttendanceChatFilterProps;
  setCopyFilters: React.Dispatch<
    React.SetStateAction<AttendanceChatFilterProps>
  >;
  setUsersList: React.Dispatch<
    React.SetStateAction<{ name: string; value: number; isVendeAI: boolean }[]>
  >;
  usersList: DropdownOptionProps[];
  isLoadingUsers: boolean;
  disabledFilter: "" | "filtro" | "filtro-rapido";
  setDisabledFilter: React.Dispatch<
    React.SetStateAction<"" | "filtro" | "filtro-rapido">
  >;
}) {
  const [errors, setErrors] = useState<{ [k: string]: string }>({});

  //   const { isLoadingAttendances } = useAttendanceKanbanContext();

  const { controls3cPlus } = use3cPlusContext();

  const onChange = (value: any, key: keyof AttendanceChatFilterProps) => {
    setErrors((err) => {
      delete err[key];
      return err;
    });

    if (Array.isArray(value)) {
      setCopyFilters((copyFilters) => {
        if (!value.length) {
          delete copyFilters[key];
          return { ...copyFilters };
        }
        return { ...copyFilters, [key]: value };
      });
    } else {
      if (value == null || value === "") {
        setCopyFilters((copyFilters) => {
          delete copyFilters[key];
          return { ...copyFilters };
        });
      } else setCopyFilters({ ...copyFilters, [key]: value });
    }
  };

  const onChangeMultiselect = (
    value: any,
    field: "userIds" | "tabulacoes" | "etapas"
  ) => {
    const currentEl = copyFilters[field] as any[] | null;
    if (currentEl?.length && currentEl != null) {
      const isInclude = currentEl.includes(value);
      if (isInclude)
        onChange(
          currentEl.filter((curr: any) => curr !== value),
          field
        );
      else onChange([...copyFilters[field]!, value], field);
    } else onChange([value], field);
  };

  const changeFilter = (
    value: AttendanceChatFilterProps,
    { disableFilter }: { disableFilter: boolean }
  ) => {
    setFilter({ ...value });
    filters = { ...value };
    if (disableFilter) setDisabledFilter("filtro-rapido");
    else setDisabledFilter("");
  };

  const resetFilter = () => {
    setDisabledFilter("");
    setFilter({ offset: 0 });
    filters = { offset: 0 };
    setCopyFilters({ offset: 0 });
  };

  return (
    <Popover
      button={
        <Button
          variant="ghost"
          alignItems="center"
          cursor="pointer"
          _hover={{ bg: "gray.200" }}
          px="10px"
          borderRadius="6px"
          leftIcon={<Filter2Icon />}
          fontSize={chatsFilterButtonsFontSize}
          fontWeight="medium"
          isDisabled={
            controls3cPlus.inCall || disabledFilter === "filtro"
            // || isLoadingAttendances
          }
          pos="relative"
          justifyContent="flex-start"
          display="flex"
          w="100%"
          border="1px solid var(--chakra-colors-gray-200)"
        >
          Filtrar por
          {Object.keys(filters).length > 1 && disabledFilter !== "filtro" ? (
            <IconButtonWithLoading
              aria-label=""
              tooltipMessage="Limpar Filtro"
              onClick={async (e) => {
                e.stopPropagation();
                e.preventDefault();
                resetFilter();
              }}
              icon={<DeleteIcon w="12px" h="12px" />}
              size="xs"
              pos="absolute"
              top="-6px"
              right="0px"
              transform="translateX(calc(20% + 3px))"
              w="18px"
              h="18px"
              minW="0px"
              variant="danger"
            />
          ) : null}
          {/* {Object.keys(filters).length > 1 ? (
            <Center
              rounded="full"
              bg="red"
              color="white"
              w="14px"
              h="14px"
              fontSize="10px"
              pos="absolute"
              top="-5px"
              right="-5px"
            >
              {Object.keys(filters).length - 1}
            </Center>
          ) : null} */}
        </Button>
      }
      title="Filtrar por"
      position="left-bottom"
      popupStyles={{ minWidth: "320px" }}
      contentProps={{ padding: "0px" }}
      onCloseEvent={() => setCopyFilters({ ...filters })}
    >
      {({ onClose }) => (
        <>
          <Box overflow="auto" maxHeight="350px" padding="8px">
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Usuário
              </Text>
              <NewDropdown
                maxH={150}
                multiSelect
                isLoading={isLoadingUsers}
                options={usersList}
                onChange={(option) =>
                  onChangeMultiselect(option.value, "userIds")
                }
                value={copyFilters.userIds}
                // isDisabled={isLoadingAttendances}
              />
            </Box>
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Convênio
              </Text>
              <NewDropdown
                maxH={150}
                containerProps={{ maxH: "200px" }}
                options={[
                  { name: "Todos", value: undefined },
                  ...dropdownConvenioAtendimento,
                ]}
                value={copyFilters.convenio}
                onChange={(option) => {
                  onChange(option.value, "convenio");
                }}
                // isDisabled={isLoadingAttendances}
              />
            </Box>
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Etapa
              </Text>
              <NewDropdown
                maxH={150}
                containerProps={{ maxH: "200px" }}
                multiSelect
                options={etapaDropdownArray}
                value={copyFilters.etapas}
                onChange={(option) => {
                  onChangeMultiselect(option.value, "etapas");
                }}
                // isDisabled={isLoadingAttendances}
              />
            </Box>
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Tabulações
              </Text>
              <NewDropdown
                maxH={150}
                containerProps={{ maxH: "200px" }}
                multiSelect
                options={dropdownTabulacao}
                value={copyFilters.tabulacoes}
                onChange={(option) => {
                  onChangeMultiselect(option.value, "tabulacoes");
                }}
                // isDisabled={isLoadingAttendances}
              />
            </Box>
            <Box mb="20px">
              <Text mb="8px" fontWeight="medium">
                Data de criação
              </Text>
              <CalendarFilter
                onChange={onChange}
                filter={copyFilters}
                keyDataInicio="fromDataCriacao"
                keyDataFim="toDataCriacao"
              />
            </Box>
            <Box mb="20px">
              <Text mb="8px" fontWeight="medium">
                Ganhos / Perdidos
              </Text>
              <GanhosPerdidosSwitch
                onChange={onChange}
                resultado={copyFilters.resultado}
              />
            </Box>
            <Flex alignItems={"center"}>
              <Checkbox
                isChecked={!!copyFilters.onlyUnreadMessage}
                onChange={(isChecked) =>
                  onChange(isChecked ? true : null, "onlyUnreadMessage")
                }
              >
                Somente não lidos
              </Checkbox>
            </Flex>
          </Box>
          <Box padding="8px">
            <Button
              w="100%"
              size="lg"
              fontSize="14"
              borderRadius="4"
              onClick={() => {
                // getAllColumnAttendances();
                changeFilter(copyFilters, { disableFilter: true });
                onClose();
              }}
            >
              Aplicar
            </Button>
          </Box>
        </>
      )}
    </Popover>
  );
}
